import * as v from 'valibot';
import {vxNullableInput, vxNumericInput} from "@root/server/client/esweb/src/lib/valibot/vx.ts";
import { parse } from "liqe";
import {ModelObject} from "objection";
import {AiModelModel} from "@root/server/routes/app/hook_filters/AiModelModel.ts";

export const hook_filter_form_name = "app--hook-filter-form";
export const monitor_row_name = "app--monitor-row";


export const HookFilterFormSchema = v.object({
    // Required
    name: v.pipe(v.string(), v.minLength(1)),

    // Search Query (Lucene syntax)
    lucene_q: v.pipe(
        vxNullableInput(),
        v.nullable(
            v.pipe(
                v.string(),
                v.maxLength(500),
                v.check(
                    (input) => !/\/.*\//.test(input),
                    'Regular expressions (e.g. /pattern/) are not allowed.'
                ),
                v.check((input) => {
                    let depth = 0;
                    const MAX_DEPTH = 5; // 5 levels is plenty for normal use

                    for (const char of input) {
                        if (char === '(') depth++;
                        else if (char === ')') depth--;

                        if (depth > MAX_DEPTH) return false;
                    }
                    return true;
                }, 'Query is too complex (too many nested parentheses).'),
                v.check((input) => {
                    try {
                        parse(input);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, (input) => {
                    try {
                        parse(input.input);
                        return 'Invalid query syntax';
                    } catch (e) {
                        return (e as Error).message;
                    }
                })
            )
        )
    ),

    prompt: v.pipe(vxNullableInput(), v.nullable(v.string())),
    heartbeat_m: v.pipe(vxNullableInput(), v.nullable(v.pipe(vxNumericInput(), v.minValue(10)))),

    ds_ntfy_url: v.pipe(vxNullableInput(), v.nullable(v.pipe(v.string(), v.url()))),
    ds_webhook_url: v.pipe(vxNullableInput(), v.nullable(v.pipe(v.string(), v.url()))),
    ds_email: v.pipe(vxNullableInput(), v.nullable(v.pipe(v.string(), v.email()))),
    process_images: v.optional(v.boolean(), false),
    dedupe_key: v.pipe(vxNullableInput(), v.nullable(v.string())),
    ai_model_id: v.pipe(vxNullableInput(), v.nullable(v.string())),
});


export const HookFilterTestFormSchema = v.object({
    content: v.pipe(v.string(), v.minLength(1)),
    contentType: v.optional(v.picklist(['application/json', 'text/plain']), 'text/plain'),
});

export type HookFilterEditFormValues = v.InferInput<typeof HookFilterFormSchema>;
export type HookFilterTestFormValues = v.InferInput<typeof HookFilterTestFormSchema>;

export interface HookFilterFormProps {
    submitUrl: string;
    initialData?: Partial<HookFilterEditFormValues> & {id?: string};
    aiModels: ModelObject<AiModelModel>[];
}
